import React, { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { navSelector } from 'store/modules/competition-nav/selectors/nav-selector';
import { Loader } from 'common/react/components/Loader';

import { RoundButton } from './RoundButton';
import { changeRound } from 'common/store/modules/competition-nav/thunks/change-round';

export const RoundListNavItem = ({ onRoundClick }) => {
    const dispatch = useDispatch();
    const nav = useSelector(navSelector);
    const roundsListRef = useRef();

    const roundElements = useRef(new Array());
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const roundId = params.Round;

    const roundsList = nav?.rounds;
    const season = nav?.season;

    useEffect(() => {
        if (roundElements?.current?.length) {
            for (const round of roundElements.current) {
                if (round && round.dataset.roundId === roundId) {
                    round.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                        inline: 'nearest'
                    });
                }
            }
        }
    }, [roundsList, roundId]);

    if (!roundsList) {
        return (
            <ul className="competition-nav__round-list">
                <Loader />
            </ul>
        );
    }

    const onNavItemClick = (event, label, disableRounds) => {
        if (
            disableRounds &&
            label?.roundNumber &&
            typeof onRoundClick === 'function'
        ) {
            onRoundClick(label.roundNumber);
        }

        roundsListRef?.current.dispatchEvent(
            new Event(PULSE.app.common.CONSTANTS.EVENTS.INTERACTION.CHANGE, {
                bubbles: true
            })
        );

        dispatch(
            changeRound({
                round: label
            })
        );
    };

    return (
        <ul className="competition-nav__round-list" ref={roundsListRef}>
            {roundsList.length
                ? roundsList.map((round) => (
                      <li
                          className="competition-nav__round-list-item-wrapper"
                          key={round.name}
                          ref={(element) => roundElements.current.push(element)}
                          data-round-id={round.id}
                      >
                          <RoundButton
                              round={round}
                              currentRoundNumber={
                                  season?.currentRoundNumber ?? -1
                              }
                              onClick={onNavItemClick}
                          />
                      </li>
                  ))
                : ''}
        </ul>
    );
};

RoundListNavItem.propTypes = {
    onRoundClick: PropTypes.func
};
